import * as React from "react";
import {useMemo, useState} from "react";
import {Link} from "react-router-dom";
import {MessageState} from "src/domain/model/user";
import {Client} from "../../../../domain/model/client";
import {Company, Status} from "../../../../domain/model/company";
import {INotificationRepository} from "../../../../domain/repository/notification_repository";
import {createApiClient, IApiClient} from "../../../../infra/api/client";
import {createNotificationAPI} from "../../../../infra/api/service/notification_api";
import LayoutSearchFormForMenu from "../../../component/layout/share/layout_search_form";
import AvatarProfile from "../../molecular/avatar_profile/avatar_profile";
import {
    ChildLinkWrapper,
    ChildOpenBtn,
    ChildrenWrapper,
    FlexWrapper,
    IconText,
    LinkText,
    MainContentWrapper,
    ParentLinkWrapper,
    StyleLink,
    UserMenuWrapper,
} from "./menu_share_components";
import UnReadCount from "./unread_count";

const apiClient: IApiClient = createApiClient();
const notificationRepository: INotificationRepository =
    createNotificationAPI(apiClient);

interface IProps {
    client: Client | null;
    messageStateList: MessageState[];
    company?: Company | null;
    handleSearchForClient: (values: any) => void;
    handleCloseMenu: (event: React.MouseEvent<HTMLElement>) => void;
}

const ClientMenu: React.FC<IProps> = (props) => {
    const {
        handleSearchForClient,
        client,
        messageStateList,
        company,
        handleCloseMenu,
    } = props;

    if (!client || !company) {
        return null;
    }

    const clientName = client.name;
    // polling のgetMe時に毎回画像を取りに走っているためMemo化
    const clientIconURL = useMemo(() => client.getIconURL(), [client.gsIconURL]);

    const [isOpenMypage, setIsOpenMypage] = useState(false);
    const [isOpenCompany, setIsOpenCompany] = useState(false);
    const [isOpenProject, setIsOpenProject] = useState(false);
    const toggleIsOpenMypage = () => {
        setIsOpenMypage(!isOpenMypage);
    };
    const toggleIsOpenCompany = () => {
        setIsOpenCompany(!isOpenCompany);
    };
    const toggleIsOpenProject = () => {
        setIsOpenProject(!isOpenProject);
    };

    const handleLinkClick =
        (setFn?: (value: any) => void) =>
            (event: React.MouseEvent<HTMLElement>) => {
                if (setFn) {
                    setFn(true);
                }
                handleCloseMenu(event);
            };

    const [notificationUnReadCount, setNotificationUnReadCount] = useState(0);

    React.useEffect(() => {
        notificationRepository.getUnReadCount().then((count) => {
            setNotificationUnReadCount(count);
        });
    }, []);

    return (
        <UserMenuWrapper>
            <FlexWrapper>
                <MainContentWrapper>
                    <LayoutSearchFormForMenu
                        onSubmit={handleSearchForClient}
                        form={"ClientScoutCustomerListSearchForm"}
                        initialValues={{
                            placeholder: "エキスパートの検索",
                        }}
                    />
                    <Link to={`/client/mypage/company`}>
                        <AvatarProfile
                            avatarURL={company.getLogoURL()}
                            avatarName={company.name}
                        />
                    </Link>

                    <ParentLinkWrapper>
                        <StyleLink to={`/`} onClick={handleLinkClick()} exact={true}>
                            <LinkText bold={true} icon={"'\f015'"} iconPrefix={"900"}>
                                ホーム
                            </LinkText>
                        </StyleLink>
                    </ParentLinkWrapper>

                    <ParentLinkWrapper>
                        <StyleLink
                            to={`/client/scout/customers`}
                            onClick={handleLinkClick()}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f2b5'"} iconPrefix={"400"}>
                                スカウト
                            </LinkText>
                        </StyleLink>
                    </ParentLinkWrapper>

                    <ParentLinkWrapper>
                        <StyleLink
                            to={`/client/agentic-search`}
                            onClick={handleLinkClick()}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f002'"} iconPrefix={"900"}>
                                AIエージェント検索
                            </LinkText>
                        </StyleLink>
                    </ParentLinkWrapper>

                    <ParentLinkWrapper>
                        <StyleLink
                            to={`/client/bookmarks`}
                            onClick={handleLinkClick()}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f004'"} iconPrefix={"400"}>
                                お気に入り
                            </LinkText>
                        </StyleLink>
                    </ParentLinkWrapper>

                    <ParentLinkWrapper>
                        <StyleLink
                            to={`/client/browsinghistories`}
                            onClick={handleLinkClick()}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f1da'"}>
                                閲覧履歴
                            </LinkText>
                        </StyleLink>
                    </ParentLinkWrapper>

                    <ParentLinkWrapper>
                        <StyleLink
                            to={`/client/entry_scout_histories`}
                            onClick={handleLinkClick()}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f500'"}>
                                エントリー一覧
                            </LinkText>
                        </StyleLink>
                    </ParentLinkWrapper>

                    {company && company.status !== Status.Status_Demo && (
                        <ParentLinkWrapper>
                            <StyleLink
                                to={`/client/messages`}
                                target="_blank"
                                rel="noopener"
                                onClick={handleLinkClick()}
                                exact={true}
                            >
                                <LinkText bold={true} icon={"'\f075'"} iconPrefix={"400"}>
                                    メッセージ
                                </LinkText>
                                <UnReadCount
                                    count={messageStateList.reduce(
                                        (sum: number, val: MessageState) => {
                                            return sum + Number(`${val.unReadCount}`);
                                        },
                                        0
                                    )}
                                    withIcon={true}
                                />
                            </StyleLink>
                        </ParentLinkWrapper>
                    )}

                    <ParentLinkWrapper>
                        <StyleLink
                            to={`/client/notifications`}
                            onClick={handleLinkClick()}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f0f3'"}>
                                お知らせ
                            </LinkText>
                            {notificationUnReadCount > 0 && (
                                <UnReadCount count={notificationUnReadCount} withIcon={false}/>
                            )}
                        </StyleLink>
                    </ParentLinkWrapper>


                    {company && company.status !== Status.Status_Demo && (
                        <div>
                            <ParentLinkWrapper isOpen={isOpenProject}>
                                <StyleLink
                                    to={`/client/projects`}
                                    onClick={handleLinkClick(setIsOpenProject)}
                                    exact={true}
                                >
                                    <LinkText bold={true} icon={"'\f0ae'"}>
                                        案件管理
                                    </LinkText>
                                </StyleLink>
                                <ChildOpenBtn
                                    isOpen={isOpenProject}
                                    onClick={toggleIsOpenProject}
                                >
                                    <IconText icon={isOpenProject ? "'\f00d'" : "'\f067'"}/>
                                </ChildOpenBtn>
                            </ParentLinkWrapper>
                            <ChildrenWrapper isOpen={isOpenProject}>
                                <ChildLinkWrapper>
                                    <StyleLink
                                        to={`/client/project/create/new`}
                                        onClick={handleLinkClick()}
                                        exact={true}
                                    >
                                        <LinkText bold={true}>案件登録</LinkText>
                                    </StyleLink>
                                </ChildLinkWrapper>
                            </ChildrenWrapper>
                        </div>
                    )}

                    <ParentLinkWrapper>
                        <StyleLink
                            to={`/client/operations`}
                            onClick={handleLinkClick()}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f024'"}>
                                稼働報告
                            </LinkText>
                        </StyleLink>
                    </ParentLinkWrapper>

                    <ParentLinkWrapper isOpen={isOpenMypage}>
                        <StyleLink
                            to={`/client/mypage/client`}
                            onClick={handleLinkClick(setIsOpenMypage)}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f007'"} iconPrefix={"400"}>
                                マイページ
                            </LinkText>
                        </StyleLink>
                        <ChildOpenBtn isOpen={isOpenMypage} onClick={toggleIsOpenMypage}>
                            <IconText icon={isOpenMypage ? "'\f00d'" : "'\f067'"}/>
                        </ChildOpenBtn>
                    </ParentLinkWrapper>
                    <ChildrenWrapper isOpen={isOpenMypage}>
                        <ChildLinkWrapper>
                            <StyleLink
                                to={`/client/mypage/client/_edit`}
                                onClick={handleLinkClick()}
                                exact={true}
                            >
                                <LinkText bold={true}>マイページ編集</LinkText>
                            </StyleLink>
                        </ChildLinkWrapper>
                        <ChildLinkWrapper>
                            <StyleLink
                                to={`/client/mypage/email`}
                                onClick={handleLinkClick()}
                                exact={true}
                            >
                                <LinkText bold={true}>メールアドレス変更</LinkText>
                            </StyleLink>
                        </ChildLinkWrapper>
                        <ChildLinkWrapper>
                            <StyleLink
                                to={`/client/mypage/password`}
                                onClick={handleLinkClick()}
                                exact={true}
                            >
                                <LinkText bold={true}>パスワード変更</LinkText>
                            </StyleLink>
                        </ChildLinkWrapper>
                    </ChildrenWrapper>

                    <ParentLinkWrapper isOpen={isOpenCompany}>
                        <StyleLink
                            to={`/client/mypage/company`}
                            onClick={handleLinkClick(setIsOpenCompany)}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f1ad'"} iconPrefix={"400"}>
                                企業ページ
                            </LinkText>
                        </StyleLink>
                        <ChildOpenBtn isOpen={isOpenCompany} onClick={toggleIsOpenCompany}>
                            <IconText icon={isOpenCompany ? "'\f00d'" : "'\f067'"}/>
                        </ChildOpenBtn>
                    </ParentLinkWrapper>
                    <ChildrenWrapper isOpen={isOpenCompany}>
                        <ChildLinkWrapper className={"ChildLinkWrapper"}>
                            <StyleLink
                                to={`/client/billing/plan`}
                                onClick={handleLinkClick()}
                                exact={true}
                            >
                                <LinkText bold={true}>料金プラン</LinkText>
                            </StyleLink>
                        </ChildLinkWrapper>
                        <ChildLinkWrapper className={"ChildLinkWrapper"}>
                            <StyleLink
                                to={`/client/clients`}
                                onClick={handleLinkClick()}
                                exact={true}
                            >
                                <LinkText bold={true}>メンバー</LinkText>
                            </StyleLink>
                        </ChildLinkWrapper>
                    </ChildrenWrapper>

                    <ParentLinkWrapper>
                        <StyleLink
                            to={`/client/consultation`}
                            onClick={handleLinkClick()}
                            exact={true}
                        >
                            <LinkText bold={true} icon={"'\f500'"}>
                                案件相談
                            </LinkText>
                        </StyleLink>
                    </ParentLinkWrapper>
                </MainContentWrapper>
            </FlexWrapper>
        </UserMenuWrapper>
    );
};

export default ClientMenu;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/menu/client_menu.tsx